<template>
  <div>
    <point-label
      :name="$t('pc_biz_lbl_task_model').d('任务模型')"
      :type="type"
      class="mb16"
    >
      <span>{{ rtDetails.modelName }}</span>
    </point-label>
    <yxt-tree
      ref="rtModelDetailTree"
      :data="rtDetails.rtList"
      :props="props"
      show-checkbox
      node-key="rtId"
      wrap-width="100%"
      default-expand-all
      :default-checked-keys="defaultCheckedKeys"
      @check-change="changeCheck"
    >
      <span slot-scope="{ data }">
        <yxt-popover :disabled="!data.taskDesc" :max-width="500" placement="bottom" trigger="hover">
          <div>
            {{ data.taskDesc }}
          </div>
          <span slot="reference">
            {{ data.name }}
          </span>
        </yxt-popover>
      </span>
    </yxt-tree>
  </div>
</template>

<script>
import pointLabel from './point-label';

export default {
  components: { pointLabel },
  props: {
    type: Number,
    rtDetails: {
      type: Object,
      default: () => { }
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      props: {
        label: 'name',
        children: 'subTasks'
      }
    };
  },
  methods: {
    changeCheck() {
      const checkList = this.$refs.rtModelDetailTree.getCheckedKeys(true);
      this.$emit('changeChecks', checkList);
    }
  }
};
</script>
